
import "./singBtn.css"

function SingBtn() {
  return (
    <div className="container">
      <ion-icon name="log-out-outline"></ion-icon>
      <div className='text'>SingBtn</div>
    </div>
  )
}

export default SingBtn